/// <amd-module name="Wit/Common/WorkItemsHubNavDataService/IWorkItemsHubNavDataService" />
import { IVssPersistantService, IVssService, ServiceOptions, Services, VssService } from "VSS/Platform/Context";

/**
 * Service to manage the navigation data for WorkItemsHub.
 * Used in the new plat by WIH and old plat for by the work item form.
 */
export interface IWorkItemsHubNavDataService extends IVssService, IVssPersistantService {
    /**
     * Sets navigation data
     * @param data
     */
    setNavigationData(data: IWorkItemsHubNavData): void;

    /**
     * Gets navigation data
     */
    getNavigationData(): IWorkItemsHubNavData;
}

/**
 * Data used by WIH to decide whether to show WorkItemsHubNavView or not.
 */
export interface IWorkItemsHubNavData {
    /**
     * Required. Used in identifying which pivot the user should be navigated on clicking "Back to work items" command.
     */
    tabId: string;
    tabName?: string;
    workItemIds?: number[];
    /**
     * Selected item's index in visible list (filtered). We can't necessarily get this from workItemIds
     * in all conditions.
     */
    selectedItemIndexInVisibleList?: number;
    /**
     * Scroll top value of the scrollable container (containing tab content) when a work item is
     * opened and we navigate away from WIH in triage view mode.
     */
    selectedIndexScrollTopValue?: number;
    lastTriagedWorkItemId?: number;
}

class WorkItemsHubNavDataService extends VssService implements IWorkItemsHubNavDataService {
    private _navigationData: IWorkItemsHubNavData;

    public setNavigationData(data: IWorkItemsHubNavData): void {
        this._navigationData = data;
    }

    public getNavigationData(): IWorkItemsHubNavData {
        return this._navigationData;
    }
}

// Register as a Persistant service in order to ensure that the value is preserved after navigating via FPS.
Services.add("IWorkItemsHubNavDataService", { serviceFactory: WorkItemsHubNavDataService, options: ServiceOptions.Persistant });
